import React from "react";
import { BetQLSportItem, PICK_TYPES } from "src/common-services";

import styles from "./styles.scss";
import RatingTrend from "./RatingTrend";
import SharpReport from "./SharpReport";
import { UpgradeButton } from "../../UpgradeButton";
import { SubscriptionContext } from "../../../services/SubscriptionService";
import MarketingVideo from "src/components/MarketingVideo";
import GameProjections from "src/components/GameProjections";
import { getFreeTrialClaimed } from "src/services/UserService";

export function getPeriodFilter(filterKey: string) {
  const fgKeys = ["total", "spread", "moneyline"];
  return fgKeys.includes(filterKey) ? `FG${filterKey}` : filterKey;
}

function getPickTypesData(currentSportObj: BetQLSportItem): any[] {
  return currentSportObj.pickTypes
    .filter((pickType) => currentSportObj[`has${getPeriodFilter(pickType)}PowerRating`])
    .map((pickType) => PICK_TYPES[pickType]);
}

interface BestBetsProps {
  game: any;
  sport: BetQLSportItem;
  loading: boolean;
}

interface BestBetsState {
  currentFilterKey: string;
}

class BestBets extends React.Component<BestBetsProps, BestBetsState> {
  static contextType = SubscriptionContext;

  constructor(props: BestBetsProps) {
    super(props);
    this.state = {
      currentFilterKey: props.sport.favoriteLine,
    };
  }

  selectPick = (selectedfilterKey: string) => {
    this.setState({ currentFilterKey: selectedfilterKey });
  };

  render() {
    const { game, sport } = this.props;
    const { currentFilterKey } = this.state;
    const { hasSubscriptionAccess, subscriptionLevel } = this.context;
    const pickTypesData = getPickTypesData(sport);
    const hasAccess = game.freeGame || hasSubscriptionAccess(sport.key);
    const trialClaimed = getFreeTrialClaimed();

    return (
      <div id="bets" className="best-bets__container">
        <div className="best-bets__nav">
          {pickTypesData.map(({ filterKey, shortName }) => (
            <div
              id={filterKey}
              key={filterKey}
              onClick={() => this.selectPick(filterKey)}
              className={`best-bets__nav-item${this.state.currentFilterKey === filterKey ? "--selected" : ""}`}
            >
              {shortName}
            </div>
          ))}
        </div>
        <div className="best-bets__main">
          <div className="best-bets__heading">
            Model Bets {!subscriptionLevel && <MarketingVideo className="best-bets__marketing-video" />}
          </div>
          <div className="best-bets__section">
            <RatingTrend
              game={game}
              filterKey={currentFilterKey}
              hasAccess={hasAccess}
              renderUpgradeButton={() => (
                <UpgradeButton className="best-bets__upgrade-button" game={game} source="Best Bets">
                  {trialClaimed ? "Upgrade now" : "Start Free Trial"}
                </UpgradeButton>
              )}
            />
          </div>
          <div className="best-bets__section">
            <GameProjections slug={game.slugId} />
          </div>
          {sport.hasSharpData ? (
            <div className="best-bets__section" id="sharp-report">
              <SharpReport
                sport={sport}
                game={game}
                filterKey={currentFilterKey}
                hasAccess={hasAccess}
                renderUpgradeButton={() => (
                  <UpgradeButton className="best-bets__upgrade-button" game={game} source="Best Bets">
                    {trialClaimed ? "Upgrade now" : "Start Free Trial"}
                  </UpgradeButton>
                )}
              />
            </div>
          ) : null}
        </div>
        <style jsx global>
          {styles}
        </style>
      </div>
    );
  }
}

export default BestBets;
